export default __webpack_public_path__ + "static/media/collaborators.b08c1a8f.svg";